import React from "react";
import { Col, Row, DatePicker } from "antd";
import InputField from "../../../../input-field";
import FieldBlock from "../../../../field-block";
import DividerBlock from "../../../../divider-block";
import SelectField from "../../../../select-field";
import i18n from "../../../../../i18n";

export default function GuarantorFields({
                                            stepFields,
                                            setFields,
                                            getFieldErrors,
                                            edit = false,
                                        }) {
    let dividerStyle = {
        margin: "15px 0px 45px 0px",
        display: "block",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        height: "1px",
    };
    return (
        <>
            <Row gutter={[16, 24]}>
                <Col lg={8} sm={24}>
                    <InputField
                        name="guarantorFirstName"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorFirstName.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorFirstName.title')}
                        required={true}
                        value={stepFields.guarantorFirstName}
                        setValue={(value) => {
                            setFields({ ...stepFields, guarantorFirstName: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} sm={24}>
                    <InputField
                        name="guarantorSecondName"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorSecondName.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorSecondName.title')}
                        required={true}
                        value={stepFields.guarantorSecondName}
                        setValue={(value) => {
                            setFields({ ...stepFields, guarantorSecondName: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} sm={24}>
                    <InputField
                        name="guarantorPatronymic"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPatronymic.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPatronymic.title')}
                        required={true}
                        value={stepFields.guarantorPatronymic}
                        setValue={(value) => {
                            setFields({ ...stepFields, guarantorPatronymic: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>

            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.contacts')}</span>
            <DividerBlock style={dividerStyle} />
            <Row gutter={[16, 24]}>
                <Col lg={8} sm={24}>
                    <InputField
                        name="guarantorPhone"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.phoneMobile.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.phoneMobile.title')}
                        required={true}
                        value={stepFields.guarantorPhone}
                        setValue={(value) => {
                            setFields({ ...stepFields, guarantorPhone: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} sm={24}>
                    <InputField
                        name="guarantorEmail"
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.email.title')}
                        required={true}
                        value={stepFields.guarantorEmail}
                        setValue={(value) => {
                            setFields({ ...stepFields, guarantorEmail: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} sm={24}>
                <SelectField
                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorCountry.title')}
                    name="guarantorCountry"
                    selectedValue={stepFields.guarantorCountry}
                    required={true}
                    values={[
                        { Id: 'Россия', Name: i18n.t('constants.countries.1') },
                        { Id: 'Беларусь', Name: i18n.t('constants.countries.2') },
                        { Id: 'Казахстан', Name: i18n.t('constants.countries.3') }
                    ]}
                    onChange={(value) => {
                        setFields({ ...stepFields, guarantorCountry: value });
                    }}
                    getErrors={getFieldErrors}
                />
                </Col>
            </Row>

            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.passport')}</span>
            <DividerBlock style={dividerStyle} />
            <Row gutter={[16, 24]}>
                {stepFields.guarantorCountry === i18n.t('constants.countries.1') ? <Col lg={8} sm={24}>
                    <InputField
                        name="guarantorPassportSerial"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPassportSerialKz.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPassportSerialKz.title')}
                        required={true}
                        value={stepFields.guarantorPassportSerial}
                        setValue={(value) => {
                            setFields({ ...stepFields, guarantorPassportSerial: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col> : null }
                <Col lg={stepFields.guarantorCountry === i18n.t('constants.countries.1') ? 8 : 16} sm={24}>
                    <InputField
                        name="guarantorPassportNumber"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPassportNumberKz.title')}
                        label={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPassportNumberKz.title')}
                        required={true}
                        value={stepFields.guarantorPassportNumber}
                        setValue={(value) => {
                            setFields({ ...stepFields, guarantorPassportNumber: value });
                        }}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} sm={24}>
                    <FieldBlock
                        name="guarantorPassportDate"
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPassportDate.title')}
                        getErrors={getFieldErrors}
                    >
                        <DatePicker
                            style={{ width: "100%" }}
                            defaultValue={stepFields.guarantorPassportDate}
                            format="DD.MM.YYYY"
                            size="large"
                            name="guarantorPassportDate"
                            allowClear={false}
                            onChange={(value) =>
                                setFields({ ...stepFields, guarantorPassportDate: value })
                            }
                        />
                    </FieldBlock>
                </Col>
            </Row>
        </>
    );
}
